export default __webpack_public_path__ + "media/images/burger-ca02767af1635cf4997ec1eab2b11d25.svg";